import { APIClient } from '@frontend/api-utils';
import { Order, OrderStatusName, OrderTriggerName } from '@frontend/order/types';
import { TriggerBody } from '@frontend/workflow/types';

export class OrderWorkflowClient extends APIClient {
    public static readonly endpoint = '/order-api/v1';

    public static async updateOrderState(accountId: string, orderId: string, state: OrderStatusName): Promise<Order> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/orders/${orderId}/change-state`, { state });
        return await this.handleResponse<Order>(response);
    }

    public static async triggerOrderState(accountId: string, orderId: string, trigger: TriggerBody<OrderTriggerName>): Promise<void> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/orders/${orderId}/trigger`, trigger);
        return await this.handleVoidResponse(response);
    }
}
